export default milliseconds => {
  if (typeof milliseconds !== 'number') {
    throw new TypeError('Expected a number');
  }

  const roundTowardsZero = milliseconds > 0 ? Math.floor : Math.ceil;

  const parsed = {
    hours: roundTowardsZero(milliseconds / 3600000) % 24,
    minutes: roundTowardsZero(milliseconds / 60000) % 60,
    seconds: roundTowardsZero(milliseconds / 1000) % 60,
  };

  const result = [];

  const add = (value, valueString) => {
    if (value === 0) {
      return;
    }

    result.push(`${value}${valueString}`);
  };

  add(parsed.hours, 'h');
  add(parsed.minutes, 'm');
  add(parsed.seconds, 's');

  return result.join(' ');
};
